window.addEventListener('load', function () {
    const _throttle = require('lodash.throttle'); // Import the throttle function
    let previousWidths = new WeakMap(); // Store element widths

    function initializeTicker() {
        const tickerContainers = document.querySelectorAll('[data-ticker-wrapper]');

        tickerContainers.forEach((tickerContainer) => {
            const animatedTickers = tickerContainer.querySelectorAll('.animate-ticker-x, .animate-ticker-x-reverse');
            const speed = tickerContainer.dataset.speed ? parseInt(tickerContainer.dataset.speed) : 20;

            animatedTickers.forEach((animatedTicker) => {
                const tickerWidth = animatedTicker.scrollWidth;
                const duration = tickerWidth / speed; // Calculate duration in seconds

                if (animatedTicker.classList.contains('absolute')) {
                    animatedTicker.style.left = tickerWidth + 'px';
                }

                // Set the animation duration dynamically
                animatedTicker.style.animationDuration = `${duration}s`;

                // Store the width
                previousWidths.set(animatedTicker, tickerWidth);
            });
        });
    }

    // Initialize on page load
    initializeTicker();

    // Check every 3 seconds if widths have changed
    setInterval(() => {
        document.querySelectorAll('.animate-ticker-x, .animate-ticker-x-reverse').forEach((el) => {
            const currentWidth = el.scrollWidth;
            const storedWidth = previousWidths.get(el) || 0;

            if (currentWidth !== storedWidth) {
                initializeTicker();
            }
        });
    }, 3000);

    // Reinitialize on window resize with throttling
    window.addEventListener('resize', _throttle(initializeTicker, 200));
});
